import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";

export default function NotFound() {
  return (
    <div className="gp-404" data-testid="not-found">
      <Seo overrideKey="/404" />
      <div>
        <div className="gp-404__num">404</div>
        <div className="gp-404__msg">This page could not be found.</div>
        <div className="gp-404__ctas">
          <Link to="/" className="gp-btn" data-testid="not-found-home">
            Back to home <span className="gp-arrow">→</span>
          </Link>
          <Link to="/contact" className="gp-link" data-testid="not-found-contact">
            Contact us <span className="gp-arrow">→</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
